<template>
  <b-card>
    <b-form @submit.prevent="save">
      <b-row>
        <b-col cols="12" md="6">
          <b-form-group label="Nome do Encargo">
            <b-form-input
              v-model="form.nome"
              placeholder="Ex: Tarifa PIX, Taxa Crédito 3x"
              required
            />
          </b-form-group>
        </b-col>

        <b-col cols="12" md="3">
          <b-form-group label="Tipo">
            <v-select
              v-model="form.tipoEncargo"
              :options="tiposEncargo"
              :reduce="val => val.value"
              label="label"
              placeholder="Selecione o tipo"
            />
          </b-form-group>
        </b-col>

        <b-col cols="12" md="3">
          <b-form-group :label="form.tipoEncargo === 'FIXO' ? 'Valor (R$)' : 'Percentual (%)'">
            <b-form-input
              v-model="form.valor"
              type="number"
              step="0.01"
              required
            />
          </b-form-group>
        </b-col>

        <b-col cols="12" md="6">
          <b-form-group label="Plano de Contas (Opcional)">
            <v-select
              v-model="form.planoDeConta"
              :options="comboPlanoContas"
              label="classe"
              placeholder="Vincular a um plano de contas"
            />
          </b-form-group>
        </b-col>

        <b-col cols="12" md="6">
          <b-form-group label="Ativo?">
            <b-form-checkbox
              id="v-ativo"
              v-model="form.ativo"
              name="check-button"
              switch
            >
              {{ form.ativo ? 'Sim' : 'Não' }}
            </b-form-checkbox>
          </b-form-group>
        </b-col>
      </b-row>

      <div class="d-flex mt-2">
        <b-button
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          variant="primary"
          class="mr-2"
          type="submit"
        >
          Salvar Encargo
        </b-button>
        <b-button
          v-ripple.400="'rgba(186, 191, 199, 0.15)'"
          variant="outline-secondary"
          @click="$emit('cancel')"
        >
          Cancelar
        </b-button>
      </div>
    </b-form>
  </b-card>
</template>

<script>
import { BCard, BRow, BCol, BFormGroup, BFormInput, BForm, BButton, BFormCheckbox } from 'bootstrap-vue'
import vSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'
import { encargoServices } from '@/api/financial/encargoServices'
import accountPlanServices from '@/api/financial/accountPlanServices'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BForm,
    BButton,
    BFormCheckbox,
    vSelect,
  },
  directives: {
    Ripple,
  },
  props: {
    encargoData: {
      type: Object,
      default: () => null,
    },
  },
  data() {
    return {
      form: {
        id: null,
        nome: '',
        valor: 0,
        tipoEncargo: 'FIXO',
        planoDeConta: null,
        ativo: true,
      },
      tiposEncargo: [
        { label: 'Valor Fixo (R$)', value: 'FIXO' },
        { label: 'Percentual (%)', value: 'PERCENTUAL' },
      ],
      comboPlanoContas: [],
    }
  },
  async created() {
    this.loadCombos()
    if (this.encargoData) {
      this.form = { ...this.encargoData }
    }
  },
  methods: {
    async loadCombos() {
      try {
        const res = await accountPlanServices.loadTable({ page: 0, size: 999, sort: 'classe', order: 'asc' })
        this.comboPlanoContas = res.data.content ? res.data.content : res.data
      } catch (error) {
        console.error('Erro ao carregar planos de contas:', error)
      }
    },
    async save() {
      try {
        if (this.form.id) {
          await encargoServices.update(this.form.id, this.form)
        } else {
          await encargoServices.insert(this.form)
        }
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Sucesso',
            icon: 'CheckIcon',
            variant: 'success',
            text: 'Encargo salvo com sucesso!',
          },
        })
        this.$emit('saved')
      } catch (error) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Erro',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
            text: 'Erro ao salvar encargo.',
          },
        })
      }
    },
  },
}
</script>
